import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import PageContainer from "../../components/PageContainer/PageContainer";
import { SinProductos } from "../../components/Modals";
import { URLs } from "../../utils/redirectStep";
import { useMediaQuery } from "@mui/material";
import { getSessionDocument } from "services/sessionStorageService";

function NoCalifica() {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("sm"));

  const modal = {
    open: true,
    showX: true,
    content: <SinProductos mobile={mobile} />,
  };

  useEffect(() => {
    const documento = getSessionDocument();
    if (!documento) {
      navigate(URLs.home);
    }
  }, []);

  const handleModalCloseClick = () => {
    window.location.href = "https://italmundo.com.uy/";
  };

  return (
    <PageContainer
      modal={modal}
      handleModalCloseClick={handleModalCloseClick}
      canonicalUrl={URLs.noCalifica}
      noImage={true}
    />
  );
}

export default NoCalifica;
